import { ServerResponse, ServerResponseN } from "../../../types/baseType";

type Request<R> = () => Promise<R>

export const ReduxAsyncThunkTry = async <ResponseType, >(thunkAPI: any, req: Request<ResponseType>) => {
    try {
        return await req()
    } catch (e) {
        return thunkAPI.rejectWithValue(e)
    }
}
// TODO! The function arguments need better typing
export const TryServerResponseRequest = async <ResponseType,>(req: Request<ServerResponse<ResponseType>>, thunkAPI: any) : Promise<ResponseType> => {
    return ReduxAsyncThunkTry(thunkAPI, async () => {
        const response = await reduxRequest(req)
        return response.data
    })
}

export const TryServerResponseNRequest = async <ResponseType,>(req: Request<ServerResponseN<ResponseType>>, thunkAPI: any) : Promise<ResponseType> => {
    return ReduxAsyncThunkTry(thunkAPI, async () => {
        const response = await reduxRequest(req)
        return response
    })
}
// TODO! The function arguments need better typing
export const TryRequest = async <ResponseType, >(req: Request<ResponseType>, thunkAPI: any, options: ReduxRequestOptions = {}) : Promise<ResponseType> => {
    return ReduxAsyncThunkTry(thunkAPI, () => reduxRequest(req, options))
}

interface ReduxRequestOptions {
    processException?: (e: Error) => Error
}

export const reduxRequest = async <ResponseType, >(req: Request<ResponseType>, options: ReduxRequestOptions = {}) : Promise<ResponseType> => {
    try {
        const response = await req() as ResponseType
        if (typeof response !== 'object') {
            throw new Error('Invalid response body. Expected JSON object.')
        } else if (response) {
            return response
        } else {
            throw new Error('Invalid response ' + response)
        }
    } catch (e: any) {
        if (options.processException)
            throw options.processException(e)
        else {
            const message = `An error occurred while fetching API ` + (e?.message || e || '')
            throw new Error(message)
        }
    }
}
